import React from 'react'
import SearchableTableACDCNotCollapsed from '../SearchableTableACDCNotCollapsed'
import CardCurrencyBrandLegendACDC from '../CardCurrencyBrandLegendACDC'

const TableACDCGA = () => {
  return (
    <div>
      <SearchableTableACDCNotCollapsed
        rowDataName="card_supported_currencies_acdc_focus_row"
        colDataName="card_supported_currencies_acdc_focus_column"
        searchKeys={['country.value', 'country.countryCode']}
        searchable={true}
      />
      <br />
      <CardCurrencyBrandLegendACDC />
    </div>
  )
}

export default TableACDCGA
